export interface ClassNameOnlyProps {
  className?: string;
}
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export type DateType = string; // YYYY-MM-DD
export const DATE_INPUT_DISPLAY_FORMAT = 'DD MMM YYYY';
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export type JSONValue =
  | string
  | number
  | boolean
  | null
  | JSONValue[]
  | { [key: string]: JSONValue };

export type JSONObject = {
  [key: string]: JSONValue;
};
